//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from "qs";
import storage from "local-storage-fallback";
import countryBlocker from "~/middleware/country";
import countries from "~/content/data/countries.json";

export default {
    data() {
        return {
            active: "United States",
            countries,
            phone: "",
            company: "",
            timeZone: "",
            ip: "",
            location: {
                ip: "",
                country_code: "",
                country_name: "",
                time_zone: "",
                timestamp: "",
                zip: "",
            },
            countryListOpen: false,
            countryList: [
                {
                    name: "Australia",
                    code: "AU",
                    dial: "61",
                },
                {
                    name: "Canada",
                    code: "CA",
                    dial: "1",
                },
                {
                    name: "Hongkong",
                    code: "HK",
                    dial: "852",
                },
                {
                    name: "New Zealand",
                    code: "NZ",
                    dial: "64",
                },
                {
                    name: "Philippines",
                    code: "PH",
                    dial: "63",
                },
                {
                    name: "Singapore",
                    code: "SG",
                    dial: "65",
                },
                {
                    name: "United Kingdom",
                    code: "GB",
                    dial: "44",
                },
                {
                    name: "United States",
                    code: "US",
                    dial: "1",
                },
            ],
        };
    },
    computed: {
        subject() {
            return "[" + this.activeCountry.code + "] White Label Reseller Request - " + this.company;
        },
        mobile() {
            return "+" + this.activeCountry.dial + this.phone;
        },
        countryListReverse() {
            return [].sort.call(this.countryList, function (a, b) {
                return b.name.localeCompare(a.name);
            });
        },
        activeCountry() {
            const self = this;
            return (
                this.countryList.filter((c) => c.name === self.active)[0] || {
                    name: "United States",
                    code: "US",
                    dial: "1",
                }
            );
        },
        url() {
            return (process.env.SITE_PATH || "https://burstsms.com") + this.$nuxt.$route.path;
        },
    },
    methods: {
        removeNAN() {
            this.phone = this.phone.replace(/[^.\d]/g, "");
        },
        isNumber(event) {
            if (isNaN(Number(event.key))) {
                return event.preventDefault();
            }
        },
        changeCountry(country) {
            if (this.countryListOpen) {
                if (this.active !== country) {
                    this.active = country;

                    // if(this.form.phone.length > 0){
                    //   this.phoneOnChange();
                    // }
                }
            }
            this.toggleCountryList();
        },
        toggleCountryList() {
            this.countryListOpen = !this.countryListOpen;
        },
        async checkRecaptcha() {
            const self = this;
            try {
                const token = await this.$recaptcha.execute("form_whitelabel");

                this.$axios({
                    url: "/.netlify/functions/captcha",
                    baseURL: "/",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        Pragma: "no-cache",
                        Expires: 0,
                    },
                    data: qs.stringify({
                        token,
                    }),
                }).then(function (response) {
                    if (response?.data?.success && response?.data?.score > 0.5) {
                        self.$refs.form.submit();
                    } else {
                        console.error("RECAPTCHA_FAIL");
                    }
                });

                await this.$recaptcha.reset();
            } catch (error) {
                console.error("Recaptcha error:", error);
            }
        },
        submitForm() {
            if (this.$refs.form.reportValidity() && this.$refs.form.checkValidity()) {
                this.checkRecaptcha();
            } else {
                console.error("Form Invalid");
            }
        },
    },
    async mounted() {
        try {
            await this.$recaptcha.init();
        } catch (e) {
            console.error(e);
        }
    },
    async created() {
        if (process.browser || process.client) {
            await countryBlocker(this.$nuxt.context);

            this.localStorage = !("localStorage" in window) ? storage : window.localStorage;

            const burstGeo = JSON.parse(this.localStorage.getItem("burst-geo-2"));

            this.location.url = window?.location.href || "https://burstsms.com";
            this.location.referrer = document?.referrer || window?.location.href;

            this.location.ip = burstGeo ? burstGeo.ip : "";
            this.location.country_code = burstGeo ? burstGeo.country_code : "";

            if (burstGeo?.data) {
                this.location.country_name = burstGeo.data.country_name || "";
                this.location.time_zone = burstGeo.data.time_zone.name || "";
                this.location.zip = burstGeo.data.zipcode || "";
                this.location.latitude = burstGeo.data.latitude || "";
                this.location.longitude = burstGeo.data.longitude || "";
            }

            this.location.timestamp = new Date().toISOString().split(".")[0].replace("T", " ");
        }
    },
};
